function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import MobileMenuItem from './MobileMenuItem.react';
import NavigationEdit from '../navigation/NavigationEdit.react';
var MobileMenu = function MobileMenu(_ref) {
  var _ref$navArr = _ref.navArr,
    navArr = _ref$navArr === void 0 ? {} : _ref$navArr;
  var _useParams = useParams(),
    app = _useParams.app,
    type = _useParams.type;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selected = _useState4[0],
    setSelected = _useState4[1];
  useEffect(function () {
    setItems(Object.values(navArr).filter(function (x) {
      return x.navbar === 'mobile-menu';
    }).filter(function (x) {
      return x.clientApp === app;
    }));
  }, [navArr, app, type]);
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 340,
      display: 'inline-block',
      verticalAlign: 'top'
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "mobile-menu",
    className: "mm"
  }, items.filter(function (x) {
    return !x.parentID;
  }).sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement(MobileMenuItem, {
      item: x,
      items: items,
      selected: selected,
      onClick: function onClick(x) {
        return setSelected(x);
      },
      key: x._id
    });
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 'calc(100% - 340px)',
      display: 'inline-block',
      verticalAlign: 'top'
    }
  }, /*#__PURE__*/React.createElement(NavigationEdit, {
    route: "mobile-navigation",
    navBarArr: ['mobile-menu']
  })));
};
export default MobileMenu;